import { createCommands } from '@tdp/common/commandHandler';
import { ILogger } from '@tdp/common/telemetry';
import { IUserPreference } from '@tdp/common/userPreferences';
import { getQueryValue } from '@tdp/core';

import { UserClientPreferenceSchema } from './userClientPreference';

export interface CreateClientSwitchCommandHandlerDependencies {
  logger: ILogger;
  userClientPreference: IUserPreference<typeof UserClientPreferenceSchema>;
}
export const createCientSwitchCommandHandler = ({
  logger,
  userClientPreference,
}: CreateClientSwitchCommandHandlerDependencies) =>
  createCommands({
    name: 'clientPreferenceCommands',
    handlers: {
      async *loadUserPreferredClient(redirectionUrl: string) {
        try {
          // Fetch user client preference from the URL query string
          const clientPreferenceEnforced = UserClientPreferenceSchema.parse(
            getQueryValue('client-preference')
          );
          // and set it in local storage.
          await userClientPreference.writePreference(clientPreferenceEnforced);
          if (clientPreferenceEnforced == 'classic') {
            logger.logUserBi({
              telemetryMarker: 'user-action-switch-to-old-client-enforced', message: `Auto-redirecting to old client: ${redirectionUrl} as as user preference is set to classic via query param`,
            });
            window.location.href = redirectionUrl;
          }
          logger.logUserBi({
            telemetryMarker: 'user-view-vnext-client-loaded-qparam-client-preference', message: `Loading vNext client as user preference is set to vNext via query param`,
          });
          return;
        } catch (_error) {
          // alert(error);
          // read the user preference from local storage and redirect to the appropriate URL.
          const readPastUserPreference =
            await userClientPreference.readPreference();

          if (readPastUserPreference.type === 'success') {
            if (readPastUserPreference.value === 'classic') {
              logger.logUserBi({
                telemetryMarker: 'user-auto-action-switch-to-old-client-from-local-storage', message: `Auto-redirecting to old client: ${redirectionUrl} as user preference is stored as classic in local storage`,
              });
              window.location.href = redirectionUrl;
            } else {
              logger.logUserBi({
                telemetryMarker: 'user-view-vnext-client-loaded-local-storage-client-preference',
                message: `Loading vNext client as user preference is stored as vNext in local storage`
              });
              return;
            }
          }
        }
        logger.logUserBi({
          telemetryMarker: 'user-view-vnext-client-loaded-without-client-preference',
          message: `Loading vNext client as there's no client preference set by user in either qparam or local storage`,
        });
        yield { payload: '', type: '' };
      },
      async *changeUserClientPreference(isProduction: boolean) {
        try {
          await userClientPreference.writePreference('classic');
        } catch (_error) {
          yield { payload: '', type: '' };
        } finally {
          logger.logUserBi({ telemetryMarker: "header-action-switch-to-old-client-triggered", message: `User triggered switch to old client, redirecting to ${isProduction ? 'production' : 'development'} URL` });
          if (isProduction) {
            window.location.href =
              'https://dev.teams.cloud.microsoft/?client-preference=classic';
          } else {
            window.location.href =
              'https://dev-int.teams.cloud.dev.microsoft/?client-preference=classic';
          }

          yield { payload: '', type: '' };
        }
      },
    },
  });
